import lazyLoadView from '@utils/lazy-load-view';

export default {
	// prefix: '',
	routes: [
		{
			path: '',
			name: 'home',
			keygen: 'inicio-view',
			component: () => lazyLoadView(import('@views/home.vue'))
		}
	]
};
